// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconBook = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M10 19h4a2 2 0 012-2h5V5h-4a6 6 0 00-5 2.682A6 6 0 007 5H3v12h5a2 2 0 012 2m-2-4a4 4 0 013 1.354V11a4 4 0 00-4-4H5v8zm8 0a4 4 0 00-3 1.354V11a4 4 0 014-4h2v8z"
    />
  );
export default SvgIconBook;
